// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"135":"light","378":"user","588":"dark"}[chunkId] || chunkId) + "." + {"135":"bbe343ea","169":"bc0ee093","378":"153665db","469":"06b7ff40","588":"0e3fac72"}[chunkId] + ".chunk.js";
};